import * as bootstrap from 'bootstrap';

/**
 * Toast severity matching backend ToastSeverity enum
 */
export enum ToastSeverity {
  Information = 0,
  Warning = 1,
  Error = 2,
}

/**
 * Toast model matching backend ToastModel
 */
export interface ToastModel {
  severity: ToastSeverity;
  message: string;
  autohide?: boolean;
  delay?: number;
  animation?: boolean;
}

const showToasts = (): void => {
  const toasts = document.querySelectorAll<HTMLElement>('.toast');
  for (let i = 0; i < toasts.length; i++) {
    const toast = new bootstrap.Toast(toasts[i]);
    toast.show();
  }
};

export async function initToastsAndAlerts(): Promise<void> {
  const toastsWrapper = document.getElementById('js-toasts-wrapper');
  const alertsWrapper = document.getElementById('js-alerts-wrapper');
  if (toastsWrapper !== null || alertsWrapper !== null) {
    await fetch('/api/notf', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        toasts: toastsWrapper !== null,
        alerts: alertsWrapper !== null,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch toasts.');
        } else {
          return response.text();
        }
      })
      .then((html) => {
        if (html) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          const notificationWrappers =
            tempDiv.querySelectorAll<HTMLElement>('.notification-wrapper');
          notificationWrappers.forEach((wrapper) => {
            const targetId = wrapper.getAttribute('data-target-id');
            if (targetId) {
              const target = document.getElementById(targetId);
              if (target) {
                target.innerHTML = wrapper.innerHTML;
              }
            }
          });

          showToasts();
        }
      })
      .catch((_error) => {
        // eslint-disable-next-line no-console
        console.error('Error:', _error);
      });
  }
}

/**
 * Show a client-side toast notification
 */
export function showToast(toast: ToastModel): void {
  const wrapper = document.getElementById('js-toasts-wrapper');
  if (!wrapper) {
    // eslint-disable-next-line no-console
    console.warn('Toast wrapper not found');
    return;
  }

  // Map severity to CSS class
  const bgClass =
    toast.severity === ToastSeverity.Information
      ? 'bg-secondary'
      : toast.severity === ToastSeverity.Warning
        ? 'bg-warning'
        : 'bg-danger';

  // Map severity to Iconify icon name (matching IconNames.cs)
  const iconName =
    toast.severity === ToastSeverity.Information
      ? 'mdi-information'
      : toast.severity === ToastSeverity.Warning
        ? 'mdi-alert'
        : 'mdi-alert';

  const autohide = toast.autohide ?? true;
  const delay = toast.delay ?? 5000;
  const animation = toast.animation ?? true;

  const toastHtml = `
    <div class="toast border-0 ${bgClass} text-white" data-bs-autohide="${autohide}" data-bs-delay="${delay}" data-bs-animation="${animation}">
      <div class="d-flex align-items-center px-2">
        <span class="iconify flex-shrink-0 me-2" data-icon="${iconName}" data-height="24" data-width="24"></span>
        <div class="toast-body">
          ${toast.message}
        </div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Zavřít"></button>
      </div>
    </div>
  `;

  wrapper.insertAdjacentHTML('beforeend', toastHtml);
  const toastElement = wrapper.lastElementChild as HTMLElement;
  const toastInstance = new bootstrap.Toast(toastElement);
  toastInstance.show();

  // Clean up after toast is hidden
  toastElement.addEventListener('hidden.bs.toast', () => {
    toastElement.remove();
  });
}
